import React from "react";
import styles from "./style.scss";
import cn from "classnames";

export const SkeletonArticle: React.FunctionComponent = () => {
  const articleNum = 3;
  return (
    <div className={styles.articleWrapper}>
      {Array.from({ length: articleNum }).map((_, index) => (
        <div key={`skeleton-article-${index}`} className={styles.articleItem}>
          <div className={cn(styles.skeletonText, styles.title)} />
          <div className={cn(styles.skeletonText, styles.description)} />
        </div>
      ))}
    </div>
  );
};
